/* eslint-env browser */
import { CSSProperties, RefObject } from 'react';

const getTopAnchorStyle = (left: number) => `
  &:after {
    border-bottom: 10px solid white;
    top: -10px;
    left: ${Math.max(left, 3)}px;
  }
`;

const getBottomAnchorStyle = (left: number) => `
  &:after {
    border-top: 10px solid white;
    bottom: -10px;
    left: ${Math.max(left, 3)}px;
  }
`;

const getAnchor = (
  target: HTMLElement,
  container: RefObject<HTMLDivElement>,
  offset: number = 0,
  fixed: boolean = false,
): [string, CSSProperties] => {
  const boxWidth = container.current?.getBoundingClientRect().width || 0;
  const boxHeight = container.current?.getBoundingClientRect().height || 0;
  const rect = target.getBoundingClientRect();
  const halfHeight = window.innerHeight / 2;
  const elementY = (fixed ? 0 : window.scrollY) + rect.top - offset;
  const elementX = rect.left + rect.width / 2 - boxWidth / 2;

  if (target.getBoundingClientRect().top < halfHeight) {
    const top = elementY + 30;

    if (window.innerWidth - boxWidth < elementX) {
      const left = window.innerWidth - (boxWidth + 15);
      return [getTopAnchorStyle(rect.left - left - 3), { top, left: window.innerWidth - (boxWidth + 15) }];
    }

    if (elementX < 15) {
      return [getTopAnchorStyle(rect.left - 18), { top, left: 15 }];
    }

    return [getTopAnchorStyle(rect.left - elementX - 3), { top, left: elementX }];
  }

  const top = elementY - boxHeight - 20;

  if (window.innerWidth - boxWidth < elementX) {
    const left = window.innerWidth - (boxWidth + 15);
    return [getBottomAnchorStyle(rect.left - left - 3), { top, left: window.innerWidth - (boxWidth + 15) }];
  }

  if (elementX < 15) {
    return [getBottomAnchorStyle(rect.left - 18), { top, left: 15 }];
  }

  return [getBottomAnchorStyle(rect.left - elementX - 3), { top, left: elementX }];
};

export default getAnchor;
